import React from 'react';
import { Typography, Box, Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const NotFound = () => {
  return (
    <Container maxWidth="md">
      <Helmet>
        <title>Page Not Found</title>
      </Helmet>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ textAlign: 'center' }}>
          <img src='/404-error.png' alt="404 Error" width={600} height={500} sx={{ backgroundColor: 'transparent' }} />
        </Box>
      </Box>
    </Container>
  );
};

export default NotFound;